import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { ISchemasEnum } from '@qtek/shared/models';
import { SchemaEditorActions } from './schemas.actions';

export const SCHEMAS_FEATURE_KEY = 'schemas';

export interface SchemasEditorState {
  schemasLoading: boolean;
  schemasError: string | null;
  selectedSchema: ISchemasEnum | null;
  schemas: ISchemasEnum[];
  productSchemaTypes: { [sid: string]: ISchemasEnum };
}

export const initialState: SchemasEditorState = {
  productSchemaTypes: {},
  schemasLoading: false,
  schemasError: null,
  selectedSchema: null,
  schemas: [],
};

export const schemasReducer = createReducer(
  initialState,
  on(SchemaEditorActions.connectSchemas, state => ({
    ...state,
    schemasLoading: true,
  })),
  on(SchemaEditorActions.getSchemasSuccess, (state, { schemas }) => ({
    ...state,
    schemasLoading: false,
    schemas,
    ...(state.selectedSchema ? {} : { selectedSchema: schemas[0] }),
  })),
  on(SchemaEditorActions.getSchemasFailure, state => ({
    ...state,
    schemasLoading: false,
    schemasError: 'Failed to load schemas',
  })),
  on(SchemaEditorActions.setSelectedSchema, (state, { sid }) => ({
    ...state,
    selectedSchema: state.schemas.find(s => s.sid === sid) || null,
  })),
  on(SchemaEditorActions.updateSchema, state => ({
    ...state,
    schemasLoading: true,
  })),
  on(SchemaEditorActions.updateSchemaSuccess, (state, { schema }) => ({
    ...state,
    schemas: state.schemas.map(s => (s.sid === schema.sid ? schema : s)),
    selectedSchema: schema,
    schemasLoading: false,
  })),
  on(SchemaEditorActions.updateSchemaFailure, (state, { error }) => ({
    ...state,
    schemasError: error,
    schemasLoading: false,
  })),
  on(SchemaEditorActions.getSchemaSuccess, (state, { schema }) => ({
    ...state,
    productSchemaTypes: {
      ...state.productSchemaTypes,
      [schema.sid]: schema,
    },
  }))
);

export const SchemasEditorFeature = createFeature({
  name: 'SchemasEditorKey',
  reducer: schemasReducer,
  extraSelectors: ({ selectProductSchemaTypes }) => ({
    selectSchemaViewBySid: (sid: string) =>
      createSelector(
        selectProductSchemaTypes,
        (schemas: { [key: string]: ISchemasEnum }) => schemas?.[sid] || null
      ),
  }),
});

export const {
  selectSchemasLoading,
  selectSchemasError,
  selectSelectedSchema,
  selectSchemas,
  selectProductSchemaTypes,
  selectSchemaViewBySid,
} = SchemasEditorFeature;
